import { useMutation } from "@tanstack/react-query";
import { ConversationFeedbackService } from "@/services/conversation/ConversationFeedbackService";

interface SubmitFeedbackArgs {
  conversationId: string;
  agentId?: string;
  rating: "positive" | "negative";
  feedbackText?: string;
}

/**
 * Persists a single thumbs up/down for a finished conversation. Keeps the
 * component → hook → service flow intact (the wrap-up never touches the service
 * directly).
 */
export const useSubmitConversationFeedback = () =>
  useMutation({
    mutationFn: async ({ conversationId, agentId, rating, feedbackText }: SubmitFeedbackArgs) => {
      const { data, error } = await ConversationFeedbackService.submitFeedback({
        conversation_id: conversationId,
        agent_id: agentId,
        rating,
        feedback_text: feedbackText,
      });
      if (error) throw error;
      return data;
    },
  });
